<template>
  <div>
    <v-row
      class="mb-6 text-center"
      justify="center"
      no-gutters
    >
      <v-col cols="6">
        <h2 class="my-2">{{ action }} notificação</h2>
        <ValidationObserver
          ref="observer"
          v-slot="{ invalid }"
        >
          <form @submit.prevent="onSubmit">
            <ValidationProvider name="title" v-slot="{ errors }">
              <v-text-field
                label="Título"
                type="text"
                v-model="title"
                :error-messages="errors"
                filled
              />
            </ValidationProvider>
            <ValidationProvider name="description" rules="required" v-slot="{ errors }">
              <v-textarea
                label="Descrição"
                v-model="description"
                :error-messages="errors"
                filled
                required
              />
            </ValidationProvider>
            <v-btn
              class="my-3"
              type="submit"
              :disabled="invalid"
            >
              {{ action }}
            </v-btn>
          </form>
        </ValidationObserver>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import NotificationService from '../../../../services/notification/notification.service';

const notificationService = new NotificationService();

export default {
  name: 'NotificationForm',
  emits: ['notification'],
  props: {
    notificationId: {
      type: String,
      required: false
    }
  },
  watch: {
    notificationId: function(newValue) {
      if (!newValue) {
        return;
      }

      notificationService
        .getActive()
        .then((response) => {
          this.title = response.data.title;
          this.description = response.data.description;

          this.action = 'Editar';
        });
    }
  },
  data: () => ({
    title: 'Rankdone informa',
    description: null,
    snackbar: false,
    snackbarText: null,
    action: 'Cadastrar'
  }),
  methods: {
    onSubmit() {
      this.$refs.observer.validate();

      const title = this.title && this.title.length ? this.title : null;

      if (this.notificationId && this.notificationId.length) {
        this.update(this.notificationId, this.description, title);
      } else {
        this.create(this.description, title);
      }

      this.action = 'Cadastrar';
      this.title = null;
      this.description = null;
    },
    create(description, title = null) {
      notificationService
        .create(description, title)
        .then((response) => {
          this.snackbar = true;
          this.snackbarText = response.data.message;

          this.$emit('notification');
        })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarText = err?.response?.data?.message ?? 'Failed to register a new notification';
        });
    },
    update(notificationId, description, title = null) {
      notificationService
        .update(notificationId, description, title)
        .then((response) => {
          this.snackbar = true;
          this.snackbarText = response.data.message;

          this.$emit('notification');
        })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarText = err?.response?.data?.message ?? 'Failed to update notification';
        });
    }
  }
};
</script>

<style scoped>

</style>
